import {DependencyInjectId} from "@@/package/const/DependencyInjectId";
import HttpClient from "@@/package/network/HttpClient";
import {type AxiosResponse} from "axios";
import {type ApplicationContextInterface} from "@@/package/application/applicationContext";
import {LevelAssessmentModel} from "~~/package/mapper/levelAssessment/model/LevelAssessmentModel";
import type LevelAssessmentTaskResponse from "~~/package/apis/levelAssessment/response/LevelAssessmentTaskResponse";
import type LevelAssessmentSubmitRequest from "~~/package/apis/levelAssessment/request/LevelAssessmentSubmitRequest";
import {LevelAssessmentResultListModel} from "~~/package/mapper/levelAssessment/model/LevelAssessmentResultListModel";
import type LevelAssessmentIdListResponse from "~~/package/apis/levelAssessment/response/LevelAssessmentIdListResponse";
import type CustomResponse from "~~/package/types/ResponseType";

export default class LevelAssessmentApi {
  protected http: HttpClient;

  constructor(context: ApplicationContextInterface) {
    this.http = context.getService<HttpClient>(DependencyInjectId.HttpClient);
  }

  public getLevelAssessmentBasicInfo(levelId :number): Promise<AxiosResponse<CustomResponse<LevelAssessmentModel>>> {
    return this.http.get<AxiosResponse<CustomResponse<LevelAssessmentModel>>>(`/v2/track-level/${levelId}`, undefined,true);
  }

  public getLevelAssessmentInfo(levelId :number): Promise<AxiosResponse<CustomResponse<LevelAssessmentModel>>> {
    return this.http.get<AxiosResponse<CustomResponse<LevelAssessmentModel>>>(`/v2/track-level/${levelId}/level-assessment/info`, undefined,true);
  }

  public getLevelAssessmentIdList(levelId :number, status: string): Promise<AxiosResponse<CustomResponse<LevelAssessmentIdListResponse>>> {
    return this.http.get<AxiosResponse<CustomResponse<LevelAssessmentIdListResponse>>>(`/v2/track-level/${levelId}/level-assessment/templates/${status}`,undefined,true);
  }

  public getLevelAssessmentTask(taskTemplateId: number, levelId: number): Promise<AxiosResponse<CustomResponse<LevelAssessmentTaskResponse>>> {
    return this.http.post<AxiosResponse<CustomResponse<LevelAssessmentTaskResponse>>, undefined>(`/v2/track-level/${levelId}/level-assessment/${taskTemplateId}`, undefined,true);
  }

  public submitAnswer(levelId: number, taskTemplateId: number, submitData: LevelAssessmentSubmitRequest): Promise<AxiosResponse<CustomResponse<boolean>>> {
    return this.http.post<AxiosResponse<CustomResponse<boolean>>, LevelAssessmentSubmitRequest>(`/v2.2/track-level/${levelId}/level-assessment/action/${taskTemplateId}`, submitData, true);
  }

  public getLevelAssessmentResultList(levelId :number): Promise<AxiosResponse<CustomResponse<LevelAssessmentResultListModel[]>>> {
    return this.http.get<AxiosResponse<CustomResponse<LevelAssessmentResultListModel[]>>>(`/v2/track-level/${levelId}/level-assessment/result`, undefined, true);
  }
}
